import { Close, HelpOutline } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from "@mui/material";
import FormActionButton from "../buttons/formActionButton.component";

const CustomDialog = ({ open, onClose, onConfirm, title, description }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="custom-dialog-title"
      aria-describedby="custom-dialog-description"
      width="auto"
      height="316px"
      sx={{
        "& .MuiDialog-paper": {
          width: "auto",
          height: "316px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          padding: 2,
        },
      }}
    >
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={() => ({
          position: "absolute",
          right: 8,
          top: 8,
        })}
      >
        <Close sx={{ width: "20px", height: "20px", color: "text.primary" }} />
      </IconButton>
      <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
        <HelpOutline sx={{ width: "40px", height: "40px" }} />
      </Box>
      <DialogTitle
        id="custom-dialog-title"
        sx={{ fontWeight: "bold", fontSize: "20px", textAlign: "center" }}
      >
        {title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="custom-dialog-description"
          sx={{ fontSize: "14px", textAlign: "center" }}
        >
          {description}
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "center", mb: 4 }}>
        <>
          <FormActionButton onClick={onConfirm} label="Conferma" />
          <FormActionButton onClick={onClose} label="Annulla" color="error" />
        </>
      </DialogActions>
    </Dialog>
  );
};

export default CustomDialog;
